// extracted by mini-css-extract-plugin
module.exports = {"item":"SidebarItem_item__1nLia","active":"SidebarItem_active__2iUTP"};